import Axios from "axios";
import {
    SET_LEAVE_DETAILS_REPORT_LIST, 
    UNSET_LEAVE_DETAILS_REPORT_LIST
} from "@/store/mutation-types";
import {
    getleaveDetailsReport,
} from "@/store/api";

const state = {
    getleaveDetailsReport: [],
};

const getters = {
    getleaveDetailsReport(state) {
        return state.getleaveDetailsReport;
    },
};

const mutations = {
    [SET_LEAVE_DETAILS_REPORT_LIST](state, data) {
        state.getleaveDetailsReport = data;
    },
    [UNSET_LEAVE_DETAILS_REPORT_LIST](state) {
        state.getleaveDetailsReport = [];
    },
};

const actions = {

    getleaveDetailsReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getleaveDetailsReport}`, { params: data })
                .then((response) => {
                    commit(SET_LEAVE_DETAILS_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_LEAVE_DETAILS_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};